import type { ComponentChildren } from 'preact';
import { Link, useRoute } from '../lib/router';
import { useFlag } from '../shell/hooks';
import { trailState } from '../shell/sections';

// An author's or a series' name as a link to its page (Discover, Part 2, n118; Kristi Nov 3: on the
// book page, the More by row, and author names in tables and cards). Plain words while the discover
// flag is off or the name has no page. `here` names the page you're on when it's a shared page
// (a book's title), so ← Back on the next page says it.
export function NameLink({ kind, id, here, children }: { kind: 'author' | 'series'; id?: string | null; here?: string; children: ComponentChildren }) {
  const on = useFlag('discover');
  const { path, state } = useRoute();
  if (!on || !id) return <>{children}</>;
  return (
    // A row or card under the link opens its book; the link opens the name's page instead.
    <span class="name-link-host" onClick={(e) => e.stopPropagation()}>
      <Link href={`/${kind}/${id}`} state={trailState(path, state, here)} class="name-link">
        {children}
      </Link>
    </span>
  );
}

/** A row's line under the title: the author (a link to their page), then the rest ("Harry Hole · Book 3"). */
export function AuthorLine({ author, authorId, rest = [] }: { author?: string | null; authorId?: string | null; rest?: (string | null | undefined)[] }) {
  const more = rest.filter(Boolean).join(' · ');
  return (
    <>
      {author ? (
        <NameLink kind="author" id={authorId}>
          {author}
        </NameLink>
      ) : null}
      {author && more ? ' · ' : ''}
      {more}
    </>
  );
}
